export default __webpack_public_path__ + "static/Highlander-4787fc91c647ef4394b032282aba5815.png";